import { Card, Grid } from "@mui/material";
import CardItem from "components/alove/CardItem";
import ItemPageContainer from "layouts/itemPageContainer";
import { Group } from "models/profile/Group";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createGroupDO, deleteGroupDO, getGroup, saveGroupDO } from "utils/groupUtils";
import { useAuth, useMaterialUIController } from "context";
import { PermissionType } from "models/BO/BoRole";
import { SMEHeader } from "layouts/itemPageContainer/userItem/profileHeader";
import { PageNumber } from "accessNumbers";
import { GroupType } from "models/profile/Group";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { EditGroupForm } from "./components/EditGroupForm";
import { GroupUsersList } from "./components/GroupUsersList";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

export const GroupsView = () => {
  const pageNumber = PageNumber.ViewInfoScreen;
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const { currentRole } = useAuth();
  const [group, setGroup] = useState({
  } as Group);
  const { id } = useParams();

  useEffect(() => {
    if (id && id !== "new") {
      getGroup(id).then((group) => setGroupObject(group));
    }
  }, [id]);

  const setGroupObject = (newGroup) => {
    setGroup(Object.assign(new Group(), newGroup));
  };

  const saveGroup = async () =>
    id === "new" ? createGroupDO(group).then((group) => navigate(-1)) : saveGroupDO(group);

  const deleteGroup = async () => deleteGroupDO(group).then(() => navigate(-1));

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="Groups" />
      <ItemPageContainer
        navItems={[
          { label: "Group settings", ref: "settings" },
          { label: "Edit group", ref: "group" },
          { label: "Group Users", ref: "users" },
          { label: "Workflow", ref: "workflow" },
        ]}
        actions={{
          actionsTitle: "Group actions",
          itemName: `Information group`,
          itemNumber: `#${group.id}`,
          actions: [
            {
              title: "Save",
              onClick: saveGroup,
              variant: "contained",
            },
          ],
        }}
        itemStatus={{
          title: "Group status",
          item: group,
          isManager: true,
          changeStatus: async (newStatus) => {
            group.statusId = newStatus;
            setGroupObject({ ...group });
            await saveGroup();
          },
        }}
        itemHeader={<SMEHeader
          showImage={false}
          indications={[{
            title: "Group",
            value: group.name,
          },{
            title: "Description",
            value: group.description,
          },{
            title: "Type",
            value: GroupType[group.type],
          }]}
          />}
        deleteItem={{
          buttonText: "Delete Group",
          contetnText: "Are you sure you want to delete this group?",
          hidden: !currentRole.hasAccess(pageNumber, PermissionType.Delete),
          onDelete: deleteGroup,
        }}
      >
        <CardItem title="Edit group" id="group">
          <EditGroupForm group={group} setGroup={setGroupObject} />
        </CardItem>
        <CardItem title="Group Users" id="users">
          <GroupUsersList groupId={group.id} />
        </CardItem>
      </ItemPageContainer>
    </DashboardLayout>
  );
};
